// process form data
function formProcess(form, action) {
	var formEl = form
	const data = Object.fromEntries(new FormData(formEl).entries());
	
	// do what is needed with the data
    //console.log(action);
	console.log("Data:: " , JSON.stringify(data));
    
    console.log(action + encodeURIComponent(JSON.stringify(data)))
    //window.location = "chooseIdioma://tlab-insideapp.pt/" + encodeURIComponent(JSON.stringify(data))

}
